import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';
export function Title(_ref) {
  var children = _ref.children,
      _ref$indent = _ref.indent,
      indent = _ref$indent === void 0 ? 'M' : _ref$indent;
  return /*#__PURE__*/React.createElement("h3", {
    className: cn(styles['title'], indent === 'S' && styles['small_indent'], indent === 'M' && styles['middle_indent'])
  }, children);
}